import { render } from "./AdminDailyReport.vue?vue&type=template&id=d4b3e55e&ts=true"
import script from "./AdminDailyReport.vue?vue&type=script&lang=ts"
export * from "./AdminDailyReport.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/adminold.quickup.uk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__